// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"843b0600","51":"3b4d1875","82":"2827bce7","99":"a4844d5e","136":"7bce3a44","139":"86839725","253":"d83dedaa","461":"79943493","462":"ad1726eb","722":"d856b35b","759":"4f87e05a","765":"20c1377f"}[chunkId] + ".chunk.js";
};